import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m3 16 4 4 4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 20V4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 4h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 8h7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 12h4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowDownWideNarrow";
const ArrowDownWideNarrow = memo(themed(Icon));
export {
  ArrowDownWideNarrow
};
//# sourceMappingURL=arrow-down-wide-narrow.js.map
